/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IngestionStatusControllerGetPipelineHealthQueryResponse, IngestionStatusControllerGetPipelineHealthQueryParams, IngestionStatusControllerGetPipelineHealth403 } from "../../models/documentIngestionStatusController/IngestionStatusControllerGetPipelineHealth";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { ingestionStatusControllerGetPipelineHealth } from "../../clients/document-ingestion-statusService/ingestionStatusControllerGetPipelineHealth";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const ingestionStatusControllerGetPipelineHealthQueryKey = (params: IngestionStatusControllerGetPipelineHealthQueryParams = {}) => [{
  url: '/api/v1/documents/ingestion-status/pipeline'
}, ...(params ? [params] : [])] as const;
export type IngestionStatusControllerGetPipelineHealthQueryKey = ReturnType<typeof ingestionStatusControllerGetPipelineHealthQueryKey>;
export function ingestionStatusControllerGetPipelineHealthQueryOptions(params?: IngestionStatusControllerGetPipelineHealthQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = ingestionStatusControllerGetPipelineHealthQueryKey(params);
  return queryOptions<IngestionStatusControllerGetPipelineHealthQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetPipelineHealth403>, IngestionStatusControllerGetPipelineHealthQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return ingestionStatusControllerGetPipelineHealth(params, config);
    }
  });
}

/**
 * @description Returns a comprehensive view of the entire ingestion pipeline health, showing how files flow through to documents and intelligence processing. Includes orphaned items, stuck processes, and alerts. Requires System Administrator role.
 * @summary Get holistic pipeline health
 * {@link /api/v1/documents/ingestion-status/pipeline}
 */
export function useIngestionStatusControllerGetPipelineHealth<TData = IngestionStatusControllerGetPipelineHealthQueryResponse, TQueryData = IngestionStatusControllerGetPipelineHealthQueryResponse, TQueryKey extends QueryKey = IngestionStatusControllerGetPipelineHealthQueryKey>(params?: IngestionStatusControllerGetPipelineHealthQueryParams, options: {
  query?: Partial<QueryObserverOptions<IngestionStatusControllerGetPipelineHealthQueryResponse, ResponseErrorConfig<IngestionStatusControllerGetPipelineHealth403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? ingestionStatusControllerGetPipelineHealthQueryKey(params);
  const query = useQuery({
    ...ingestionStatusControllerGetPipelineHealthQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<IngestionStatusControllerGetPipelineHealth403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}